import type { FC } from 'react'
import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import classNames from 'classnames'
import { format } from 'date-fns'
import { Image } from '@/components/ui'
import { EJournalRoute } from '@/types'
import { useFormatPublicationDate } from '@/utils/hooks/format/useFormatPublicationDate'
import { createRouterLink } from '@/utils/url'
import type { IJournalSearchListCardProps } from './types'
import './styles.scss'

export const JournalSearchListCard: FC<IJournalSearchListCardProps> = props => {
  const { itemData } = props
  const { title, subtitle, publicationDate, rectangleCover, slug } = itemData

  const suggestionLink = createRouterLink(EJournalRoute.PUBLICATION_ITEM, { publicationSlug: slug })
  const { formatPublicationDate } = useFormatPublicationDate()

  const imageClassName = classNames('journalSearchListCard__image', { 'hidden-sm': !rectangleCover })
  const mobileTextStyle = { 'text_center-sm': !rectangleCover }
  const titleClassName = classNames(mobileTextStyle, 'h4-from-sm', 'h3-sm')
  const subTitleClassName = classNames(mobileTextStyle, 'text_small-sm')

  const timeClassName = classNames('text_small journalSearchListCard__date', mobileTextStyle, {
    'text_super-small-sm': rectangleCover,
  })

  return (
    <CommonLink url={suggestionLink} className="journalSearchListCard">
      <Image className={imageClassName} src={rectangleCover} />

      <div className="journalSearchListCard__body">
        <div className="journalSearchListCard__body_top">
          <p className={titleClassName}>{title}</p>

          {subtitle && <p className={subTitleClassName}>{subtitle}</p>}
        </div>

        <time className={timeClassName} itemProp="publishedDate" dateTime={format(new Date(publicationDate), 'yyyy-MM-dd')}>
          {formatPublicationDate(publicationDate)}
        </time>
      </div>
    </CommonLink>
  )
}
